<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between mb-4 font-weight-bold">
        <span class="">
          {{ $t(`manageplan.component.card.subTotal.todayTotal`) }}
        </span>

        <span>{{ totalPrice ? formatNumber(totalPrice) : '' }} €</span>
      </li>
      <!--       <li>
        <p class="font-weight-normal font-sm text-gray-500">
          {{ $t(`manageplan.component.card.subTotal.description1`) }}
        </p>
        <p class="font-weight-normal font-sm text-gray-500">
          {{ $t(`manageplan.component.card.subTotal.description2`) }}
        </p>
      </li> -->
    </ul>
    <CButton v-if="hasPurchases" color="primary w-100 py-3 font-xl my-3" @click.prevent="confirmpaymentintent" :disabled="loading">
      {{ $t(`manageplan.component.card.subTotal.button.pay`) }}
    </CButton>
  </CCardBody>
</template>

<script>
import services from '@/services.js'
import services2 from '@/services/services.js'
import { mapGetters, mapState } from 'vuex'
import { currencyFormat, currencyFormatStyleEnum } from '@/utils/numbersFormatUtil.js'

import { getItem } from '@/utils/StorageManager'

export default {
  name: 'CardTotals',
  props: {
    hasPurchases: {
      type: Boolean,
      default: false,
    },
    // totalPrice: {
    //   type: Number,
    //   default: 0,
    // },
  },

  data() {
    return {
      organizationId: null,
      stripe: null,
      loading: false,
    }
  },

  created() {
    this.stripe = window.Stripe(this.$configs.VUE_APP_STRIPE_PK, {
      locale: this.lang.split('-')[0],
    })
  },

  mounted() {
    this.organizationId = this.$route.params.organizationId
  },

  computed: {
    ...mapState('backOffice/steps', {
      totalPrice: (state) => state.totalPrice,
    }),
    ...mapGetters({
      lang: 'getLang',
    }),
  },

  methods: {
    formatNumber(number) {
      return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
    },

    setModal(typeModal, message) {
      this.$store.dispatch('backOffice/steps/setModalComponent', { modalName: 'modalpayment', componentName: typeModal, messageModal: message })
    },

    confirmpaymentintent() {
      this.loading = true

      const stateStep = JSON.parse(getItem('stateStep'))
      if (!stateStep.billingInfo?.detailCountry) {
        stateStep.billingInfo.detailCountry = stateStep.billingInfo.countryId == 'PT' ? 'portugal' : stateStep.billingInfo.countryId
      }

      const info = {
        locale: getItem('lang') || this.lang,
        billingInfo: stateStep.billingInfo,
        planId: stateStep.selectedPlanId,
        planTierId: stateStep.selectedTierId,
        promoConfigId: stateStep.promoConfigId,
        PeriodPlanTierPriceId: stateStep.periodPlanTierPriceId,
        period: stateStep.paymentPeriod,
        stripePaymentMethodId: !stateStep.selectPayment.iframe ? stateStep.selectPayment.paymentMethodId : null,
        setupIntent: stateStep.setupIntent || null,
        setupIntentClientSecret: stateStep.customer.setupSecret,
      }

      info.billingInfo.address = info.billingInfo.streetAddress
      delete info.billingInfo.streetAddress

      services
        .confirmpaymentintent(this.organizationId, info)
        .then(({ data }) => {
          this.setModal('modalLoadingPayment')

          const STRIPE = JSON.parse(JSON.stringify(data.data))

          if (data.data.status == 'processing') {
            this.stripePaymentIntentId(data.data.stripeJs)
          }

          if (data.data.status == 'requires_action') {
            this.pay(STRIPE.stripePaymentIntentClientSecretId, STRIPE.stripePaymentMethodId)
          }

          if (data.data.status == 'succeeded') {
            this.$store.dispatch('auth/getUserSession', this.$route.params.organizationId).finally(() => this.setModal('ModalSuccessPayment'))
          }
        })
        .catch((error) => {
          const erros = error.response.data.errorParameters.reduce((acc, cur) => {
            if (acc == undefined) {
              acc = {}
            }

            if (cur.includes('ErrorCode:')) {
              acc.ErrorCode = cur.split(':')[1].trim()
            }

            if (cur.includes('DeclineCode:')) {
              acc.DeclineCode = cur.split(':')[1].trim()
            }

            return acc
          }, {})

          this.handleNotifyPaymentError(
            {
              error,
              errorCode: erros?.ErrorCode || 'UNKNOWN',
              declineCode: erros?.DeclineCode,
            },
            stateStep.customer.setupSecret,
            info.stripePaymentMethodId
          )

          // consegui simular apenas os erros CARD_DECLINED
          const message = `${erros?.ErrorCode}_${erros.DeclineCode ? erros.DeclineCode : ''}`
          this.setModal(
            'ModalErrorPayment',
            this.$te(`general.stripe.error.${message.toUpperCase()}`)
              ? this.$t(`general.stripe.error.${message.toUpperCase()}`)
              : error.response.message,
          )
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleNotifyPaymentError({ error, errorCode, declineCode }, setupIntent, paymentMethodId) {
      const messageParts = [
        `🔴 Stripe Payment Error Report`,
        `Error Code: ${errorCode || 'N/A'}`,
        `Decline Code: ${declineCode || 'N/A'}`,
        `Stripe Payment Method ID: ${paymentMethodId || 'N/A'}`,
        `Message: ${error?.response?.data?.message || error?.message || 'No message available'}`,
        `Stack Trace:\n${error?.stack || JSON.stringify(error?.response?.data || {}, null, 2)}`,
      ]

      const formattedMessage = messageParts.join('\n\n')

      services2.notifyPaymentError(this.organizationId, {
        userId: this.$store.state.auth.user.id,
        stripeSetupIntent: setupIntent,
        errorMessage: formattedMessage,
      })
    },

    stripePaymentIntentId(stripeObj) {
      services
        .stripePaymentIntentId(this.organizationId, stripeObj)
        .then(({ data }) => {
          if (data.data.status == 'succeeded') {
            this.setModal('ModalSuccessPayment')

            setTimeout(() => {
              this.$router.replace({ name: 'home' }).then(() => {
                this.$store.commit('backOffice/steps/RESET_STEP')
                this.$store.commit('backOffice/steps/RESET_PAYMENT')
              })
            }, 3000)
          }

          if (data.data.status == 'processing') {
            this.stripePaymentIntentId(stripeObj)
          }
        })
        .catch((error) => {
          this.setModal('ModalErrorPayment', error.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },

    async pay(PAYMENT_INTENT_CLIENT_SECRET, PAYMENT_METHOD_ID) {
      this.loading = true

      // const setupIntent = await this.stripe
      await this.stripe
        .confirmCardPayment(PAYMENT_INTENT_CLIENT_SECRET, {
          payment_method: PAYMENT_METHOD_ID,
        })
        .then(() => {
          this.setModal('ModalSuccessPayment')
        })
        .catch((error) => {
          this.setModal('ModalErrorPayment', error.response.message)
        })
        .finally(() => {
          this.loading = false
        })
    },

    applyDiscount(value) {
      if (this.period == 3) {
        let discount = value * 0.1
        let newValue = value - discount
        return newValue.toFixed(1)
      }

      return value
    },
  },
}
</script>

<style lang="scss">
p {
  line-height: 1.1rem;
}
</style>
